<div
	class="progress-bar-step"
	[ngClass]="{ 'is--active': isActive, 'is--completed': isCompleted }"
>
	<span class="progress-bar-step__label">{{ label }}</span>
	<span
		class="progress-bar-step__indicator"
		aria-hidden="true"
		[ngClass]="{'progress-bar-step__completed': isCompleted}"
	></span>
</div>
